const message = {
  path: '/message',
  component: resolve => require(['../../../../pages/modules/message'], resolve),
  meta: {
    requireAuth: true
  }
}

export default message